import { alpha, styled } from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

const STRIPE_OPACITY = 0.2;

export const StripedDataGrid = styled(DataGrid)(({ theme }) => {
  const headerStyle = {
    backgroundColor: "#20496e",
    color: "white",
    fontWeight: "bold !important",
  };

  const evenRowStyle = {
    backgroundColor: theme.palette.grey[200],
  };

  const hoverStyle = {
    backgroundColor: alpha(theme.palette.primary.main, STRIPE_OPACITY),
  };

  const selectedStyle = {
    backgroundColor: alpha(
      theme.palette.primary.main,
      STRIPE_OPACITY + theme.palette.action.selectedOpacity
    ),
  };

  const hoverSelectedStyle = {
    backgroundColor: alpha(
      theme.palette.primary.main,
      STRIPE_OPACITY +
        theme.palette.action.selectedOpacity +
        theme.palette.action.hoverOpacity
    ),
  };

  const resetOnTouchStyle = {
    backgroundColor: alpha(
      theme.palette.primary.main,
      STRIPE_OPACITY + theme.palette.action.selectedOpacity
    ),
  };

  return {
    "& .app-theme--header": headerStyle,
    [`& .${gridClasses.row}.even`]: {
      ...evenRowStyle,
      "&:hover, &.Mui-hovered": {
        ...hoverStyle,
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
      "&.Mui-selected": {
        ...selectedStyle,
        "&:hover, &.Mui-hovered": {
          ...hoverSelectedStyle,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": resetOnTouchStyle,
        },
      },
    },
  };
});
